import { Edit as EditIcon } from '@material-ui/icons';
import { t } from '@lingui/macro';

import { Action } from './Actions';
import { useDashboardContext } from '../dashboard/DashboardContext';

export default function EditDashboardAction(props) {
    const { dashboardActions } = useDashboardContext();
    return (
        <Action
            icon={<EditIcon />}
            tooltip={t`Edit this dashboard`}
            onClick={() => dashboardActions.setEditing(true)}
            {...props}
        />
    );
}
